import ArticleEditor from './ArticleEditor';

export default ArticleEditor;
